/**
 * - The help screen shows the faq section unless overridden by the feature flag with an appropriate key
 * - The Search help screen will show the same faq section or same articles as the help screen, unless overridden by moreArticles or a category from the feature flag
 * - When moreArticles and a category is provided, the moreArticles will take precedence and show on the search screen
 * - When a category is provided, it has to also be enabled with enabled set to true as it pulls from api by category
 * - It's possible to add a custom title to an article by adding a customTitle property to the article object in the feature flag
 * - It's possible to add a custom title to the Search helps screen by adding a title property to the moreArticles object or the categoryTitle property in the feature flag
 * - It's possible to replace the 'Related topics' header on the Help screen by adding a headerTitle property to the screen object in the feature flag; it also acts as the last fallback title on the Search help screen
 * - It's possible to omit the faq section by setting omitFaq to true in the feature flag
 * - All articles in the feature flag are referenced by article id, make sure the articles are provided in the articles object in the feature flag
 * - The moreArticlesKey is used to reference the moreArticles object in the feature flag, make sure the key is provided in the moreArticlesKey property in the feature flag, the key can be any string
 * - For US articles, add the url_us property to the article object in the feature flag, for US categories, add the categoryIdUs property to the category object in the feature flag
 * - When no articlesKey is passed to the Help screen, the 'default' screens key from the feature flag is used; if it's not configured, the hardcoded faq section shows
 */
/**
 * Feature flag screens keys to match the enum values
 */
export var HELP_ARTICLES_KEY;
(function (HELP_ARTICLES_KEY) {
    HELP_ARTICLES_KEY["DEFAULT"] = "default";
    HELP_ARTICLES_KEY["SETTINGS"] = "settings";
    HELP_ARTICLES_KEY["MANAGE_SUBSCRIPTION"] = "manage_subscription";
    HELP_ARTICLES_KEY["EXPORT_DATA"] = "export_data";
    HELP_ARTICLES_KEY["SPLIT_TRANSACTION"] = "split_transaction";
    HELP_ARTICLES_KEY["TRANSACTIONS_HELP"] = "transactions_help";
    HELP_ARTICLES_KEY["BUDGETING_ONBOARDING"] = "budgeting_onboarding";
    HELP_ARTICLES_KEY["BUDGETING"] = "budgeting";
    HELP_ARTICLES_KEY["ROLLING_BUDGETS"] = "rolling_budgets";
    HELP_ARTICLES_KEY["COMMITTED_SPENDING"] = "committed_spending";
    HELP_ARTICLES_KEY["PICK_CATEGORY"] = "pick_category";
    HELP_ARTICLES_KEY["CUSTOM_CATEGORIES"] = "custom_categories";
    HELP_ARTICLES_KEY["BANK_CONNECT"] = "bank_connect";
    HELP_ARTICLES_KEY["CONNECT_CONSENT"] = "connect_consent";
    HELP_ARTICLES_KEY["CONNECT_CRYPTO"] = "connect_crypto";
    HELP_ARTICLES_KEY["GIFT_CARD"] = "gift_card";
    HELP_ARTICLES_KEY["ORGANISATION"] = "organisation";
    HELP_ARTICLES_KEY["INVITES"] = "invites";
    HELP_ARTICLES_KEY["POTS_ONBOARDING"] = "pots_onboarding";
    HELP_ARTICLES_KEY["POTS_WITHDRAW"] = "pots_withdraw";
    HELP_ARTICLES_KEY["POTS_DEPOSIT"] = "pots_deposit";
    HELP_ARTICLES_KEY["POTS_SETTINGS"] = "pots_settings";
    HELP_ARTICLES_KEY["STATEMENT_POTS"] = "statement_pots";
    HELP_ARTICLES_KEY["STATEMENT_PERIOD"] = "statement_period";
    HELP_ARTICLES_KEY["AUTOSAVE"] = "autosave";
    HELP_ARTICLES_KEY["AUTOSAVE_ACTIVITY"] = "autosave_activity";
    HELP_ARTICLES_KEY["AUTOSAVE_ONBOARDING"] = "autosave_onboarding";
    HELP_ARTICLES_KEY["AUTOSAVE_RULES"] = "autosave_rules";
    HELP_ARTICLES_KEY["CASHBACK"] = "cashback";
    HELP_ARTICLES_KEY["PRE_APPROVED_TRANSFERS"] = "pre_approved_transfers";
    HELP_ARTICLES_KEY["PAY_REQUEST"] = "pay_request";
    HELP_ARTICLES_KEY["PAY"] = "pay";
    HELP_ARTICLES_KEY["PAY_TRANSFER"] = "pay_transfer";
    HELP_ARTICLES_KEY["RENT_REPORTING"] = "rent_reporting";
    HELP_ARTICLES_KEY["RENT_REPORTING_ONBOARDING"] = "rent_reporting_onboarding";
    HELP_ARTICLES_KEY["RENT_REPORTING_ONBOARDING_RENT"] = "rent_reporting_onboarding_rent";
    HELP_ARTICLES_KEY["RENT_REPORTING_ONBOARDING_ACCOUNT"] = "rent_reporting_onboarding_account";
    HELP_ARTICLES_KEY["RENT_REPORTING_ONBOARDING_RECENT"] = "rent_reporting_onboarding_recent";
    HELP_ARTICLES_KEY["RENT_REPORTING_ONBOARDING_CONFIRM"] = "rent_reporting_onboarding_confirm";
    HELP_ARTICLES_KEY["RENT_REPORTING_ONBOARDING_REVIEW"] = "rent_reporting_onboarding_review";
    HELP_ARTICLES_KEY["LOAN"] = "loan";
    HELP_ARTICLES_KEY["LOAN_ONBOARDING"] = "loan_onboarding";
    HELP_ARTICLES_KEY["NATIONAL_INSURANCE_NUMBER"] = "national_insurance_number";
    HELP_ARTICLES_KEY["NATIONAL_INSURANCE_NUMBER_CASH_ISA"] = "national_insurance_number_cash_isa";
})(HELP_ARTICLES_KEY || (HELP_ARTICLES_KEY = {}));
